import {CarbonDioxideEmissionClassSelect} from './CarbonDioxideEmissionClassSelect';

/**
 * @deprecated Use CarbonDioxideEmissionClassSelect instead.
 * This component is kept for backward compatibility.
 */
export function EmissionCo2ClassSelect() {
  return <CarbonDioxideEmissionClassSelect />;
}
